// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1kJ5b","errorLogs":"styles_errorLogs__1HEi4"};